import { createReducer } from 'redux-act';
import actions from '../actions/clientActions';

const initialState = {
  addClientPending: false,
  addClientRes: null,
  addClientError: null,

  getAllClientPending: false,
  getAllClientRes: null,
  getAllClientError: null,

  getClientListPending: false,
  getClientListRes: null,
  getClientListError: null,

  updateClientPending: false,
  updateClientRes: null,
  updateClientError: null,

  deleteClientPending: false,
  deleteClientRes: null,
  deleteClientError: null,

  getClientDetailsPending: false,
  getClientDetailsRes: null,
  getClientDetailsError: null,

    updateClientDetailsPending: false,
    updateClientDetailsRes: null,
    updateClientDetailsError: null,
};
/* Add Client Reducers */
const handleAddClientRequest = state => {
  return {
    ...state,
    ...{
      addClientPending: true,
      addClientRes: null,
      addClientError: null,
    },
  };
};
const handleAddClientSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addClientPending: false,
      addClientRes: payload,
      addClientError: null,
    },
  };
};
const handleAddClientError = (state, payload) => ({
  ...state,
  ...{
    addClientPending: false,
    addClientRes: null,
    addClientError: payload,
  },
});


/* Get All Client Reducers */
const handleGetAllClientRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllClientPending: true,
      getAllClientRes: null,
      getAllClientError: null,
    },
  };
};
const handleGetAllClientSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllClientPending: false,
      getAllClientRes: payload,
      getAllClientError: null,
    },
  };
};
const handleGetAllClientError = (state1, payload) => ({
  ...state1,
  ...{
    getAllClientPending: false,
    getAllClientRes: null,
    getAllClientError: payload,
  },
});

/* Get Client List Reducers */
const handleGetClientListRequest = state1 => {
  return {
    ...state1,
    ...{
      getClientListPending: true,
      getClientListRes: null,
      getClientListError: null,
    },
  };
};
const handleGetClientListSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getClientListPending: false,
      getClientListRes: payload,
      getClientListError: null,
    },
  };
};
const handleGetClientListError = (state1, payload) => ({
  ...state1,
  ...{
    getClientListPending: false,
    getClientListRes: null,
    getClientListError: payload,
  },
});

/* Update Client Reducers */
const handleUpdateClientRequest = state1 => {
  return {
    ...state1,
    ...{
      updateClientPending: true,
      updateClientRes: null,
      updateClientError: null,
    },
  };
};
const handleUpdateClientSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateClientPending: false,
      updateClientRes: payload,
      updateClientError: null,
    },
  };
};
const handleUpdateClientError = (state1, payload) => ({
  ...state1,
  ...{
    updateClientPending: false,
    updateClientRes: null,
    updateClientError: payload,
  },
});

/* Delete Client Reducers*/ 
const handleDeleteClientRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteClientPending: true,
      deleteClientRes: null,
      deleteClientError: null,
    },
  };
};
const handleDeleteClientSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteClientPending: false,
      deleteClientRes: payload,
      deleteClientError: null,
    },
  };
};
const handleDeleteClientError = (state1, payload) => ({
  ...state1,
  ...{
    deleteClientPending: false,
    deleteClientRes: null,
    deleteClientError: payload,
  },
});

/* get client details Reducers */
const handleGetClientDetailsRequest = state => {
  return {
    ...state,
    ...{
      getClientDetailsPending: true,
      getClientDetailsRes: null,
      getClientDetailsError: null,
    },
  };
};
const handleGetClientDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getClientDetailsPending: false,
      getClientDetailsRes: payload,
      getClientDetailsError: null,
    },
  };
};
const handleGetClientDetailsError = (state, payload) => ({
  ...state,
  ...{
    getClientDetailsPending: false,
    getClientDetailsRes: null,
    getClientDetailsError: payload,
  },
});

const handleUpdateClientDetailsRequest = state => {
  return {
    ...state,
    ...{
      updateClientDetailsPending: true,
      updateClientDetailsRes: null,
      updateClientDetailsError: null,
    },
  };
};
const handleUpdateClientDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateClientDetailsPending: false,
      updateClientDetailsRes: payload,
      updateClientDetailsError: null,
    },
  };
};
const handleUpdateClientDetailsError = (state, payload) => ({
  ...state,
  ...{
    updateClientDetailsPending: false,
    updateClientDetailsRes: null,
    updateClientDetailsError: payload,
  },
});



// Clear Existing Data Store Reducers*/
const clearClientStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_CLIENT_STORE':
      return {
        ...state,
        ...{
          addClientPending: false,
          addClientRes: null,
          addClientError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_CLIENT_STORE':
      return {
        ...state,
        ...{
          updateClientPending: false,
          updateClientRes: null,
          updateClientError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_CLIENT_STORE':
      return {
        ...state,
        ...{
          deleteClientPending: false,
          deleteClientRes: null,
          deleteClientError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_CLIENT_LIST_STORE':
      return {
        ...state,
        ...{
          getClientListPending: false,
          getClientListRes: null,
          getClientListError: null,
        },
      };
      case 'HANDLE_CLEAR_GET_ALL_CLIENT_STORE':
        return {
          ...state,
          ...{
            getAllClientPending: false,
            getAllClientRes: null,
            getAllClientError: null,
          },
        };
        case 'HANDLE_CLEAR_GET_CLIENT_DETAILS_STORE':
        return {
          ...state,
          ...{
            getClientDetailsPending: false,
            getClientDetailsRes: null,
            getClientDetailsError: null,
          },
        };
         case 'HANDLE_CLEAR_UPDATE_CLIENT_DETAILS_STORE':
        return {
          ...state,
          ...{
            updateClientDetailsPending: false,
            updateClientDetailsRes: null,
            updateClientDetailsError: null,
          },
        };
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.addClientRequest]: handleAddClientRequest,
    [actions.addClientSuccess]: handleAddClientSuccess,
    [actions.addClientError]: handleAddClientError,

    [actions.getAllClientRequest]: handleGetAllClientRequest,
    [actions.getAllClientSuccess]: handleGetAllClientSuccess,
    [actions.getAllClientError]: handleGetAllClientError,

    [actions.getClientListRequest]: handleGetClientListRequest,
    [actions.getClientListSuccess]: handleGetClientListSuccess,
    [actions.getClientListError]: handleGetClientListError,

    [actions.updateClientRequest]: handleUpdateClientRequest,
    [actions.updateClientSuccess]: handleUpdateClientSuccess,
    [actions.updateClientError]: handleUpdateClientError,

    [actions.deleteClientRequest]: handleDeleteClientRequest,
    [actions.deleteClientSuccess]: handleDeleteClientSuccess,
    [actions.deleteClientError]: handleDeleteClientError,

    [actions.getClientDetailRequest]: handleGetClientDetailsRequest,
    [actions.getClientDetailSuccess]: handleGetClientDetailsSuccess,
    [actions.getClientDetailError]: handleGetClientDetailsError,

    [actions.updateClientDetailsRequest]: handleUpdateClientDetailsRequest,
    [actions.updateClientDetailsSuccess]: handleUpdateClientDetailsSuccess,
    [actions.updateClientDetailsError]: handleUpdateClientDetailsError,

    [actions.handleClearClientStore]: clearClientStore,
  },
  initialState,
);